import React from "react";

const CopyrightFooter = () => (
  <div className="text-center text-slate-300 text-[10px] mt-8 pb-4 font-medium tracking-wide">
    Copyright © 2025 大帥的數理AI教室. 系統邏輯已申請專利保護，抄襲必究。
  </div>
);

export default CopyrightFooter;

